import CatalogOptions from "./CatalogOptions";
import CatalogFilters from "./CatalogFilters";
import CatalogSimpleHeader from "./CatalogSimpleHeader";

import React, { Component } from "react";

export class CatalogHeader extends Component {
  render() {
    const {
      campaign,
      onProductTextSearch,
      optionActions,
      defaultValues,
      optionState,
      onBrandChange,
      brands,
      selectedBrand,
      onFilterHide,
      onFilterShow,
      generateFilterActions,
      generateFilterState,
      filtering,
      orderOptions,
      selectedOrder,
      onOrderChange,
    } = this.props;
    return (
      <>
        <CatalogSimpleHeader
          campaign={campaign}
          selectedOrder={selectedOrder}
          onOrderChange={onOrderChange}
          orderOptions={orderOptions}
          searching
          filtering={filtering}
          onFilterHide={onFilterHide}
          onFilterShow={onFilterShow}
          onProductTextSearch={onProductTextSearch}
        />
        <div
          className={[
            "catalog-search-header-container gl-catalog__search-elements text-color",
            filtering && "gl-catalog__search-elements--extended",
          ].join(" ")}
        >
          <div className="catalog-search-header-options-container">
            {/* SearchButton */}
            <CatalogOptions
              campaign={campaign}
              optionState={optionState}
              optionActions={optionActions}
              defaultValues={defaultValues}
              onBrandChange={onBrandChange}
              brands={brands}
              selectedBrand={selectedBrand}
              generateFilterActions={generateFilterActions}
              generateFilterState={generateFilterState}
              selectedOrder={selectedOrder}
              onOrderChange={onOrderChange}
              orderOptions={orderOptions}
            />
          </div>
          {/* <div className="catalog-search-header-filters">
            <CatalogFilters
              className="catalog-search-header-filters-content"
              campaign={campaign}
              filterActions={generateFilterActions()}
              filterState={generateFilterState()}
            />
          </div> */}
        </div>
      </>
    );
  }
}

export default CatalogHeader;
